export default __webpack_public_path__ + "static/media/mok.387d47aa.png";